/**
 * 统计概况
 */
import { OVERVIEWSTATISTICS } from '../types';

export default {
    name: `${OVERVIEWSTATISTICS}`,
    path: '/overviewStatistics',
    component: () => import(/* webpackChunkName: 'overviewStatistics' */ '@/views/overviewStatistics/'),
    redirect: { name: `${OVERVIEWSTATISTICS}Index` },
    meta: {
        title: '统计概况',
        savedPosition: { x: 0, y: 0 },
        noCache: true,
    },
    children: [
        {
            name: `${OVERVIEWSTATISTICS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'overviewStatisticsIndex' */ '@/views/overviewStatistics/home/Home.vue'),
        },
        {
            name: 'AccidentClueAssigneeStatistics',
            path: 'clueAssigneeDetail',
            component: () => import(/* webpackChunkName: 'overviewStatisticsDetail' */ '@/views/overviewStatistics/detail/Detail.vue'),
        },
    ],
};
